import { preloadNavigationToPDP } from "@faire/retailer/views/product/preload/preloadNavigationToPDP";

import { useGetProductTileClickImpressions } from "./useGetProductTileClickImpressions";
import { ProductClickForSearchPageParameters } from "./useOnProductClickForSearchPage";

export const useOnProductClickBase = (
  params: ProductClickForSearchPageParameters
) => {
  const { recordProductTileClickEvent } =
    useGetProductTileClickImpressions(params);

  return () => {
    preloadNavigationToPDP({
      productToken: params.token,
      bestImage: params.bestImage,
      images: params.images ?? [],
    });
    recordProductTileClickEvent();
  };
};
